import { useConfirmOrderTransport } from "hooks/useOrders";
import { Form, FormInstance, Input, Select, Typography, message } from "antd";
import { GetOrderDetailData, Transportpostallist } from "services/interface";
import dayjs from "dayjs";
import { useGetShippingBand } from "hooks/useMasterData";
import { useEffect } from "react";
import { useAppSelector } from "store";

interface PostalSelectProps {
  formPostal: FormInstance<any>;
  item: GetOrderDetailData;
  refetchData: () => void;
  refectShipped?: () => void;
  onClose: () => void;
  memo: string;
}

const { Option } = Select;

const PostalSelect = ({ formPostal, item, refetchData, refectShipped, onClose, memo }: PostalSelectProps) => {
  const factoryId = useAppSelector((state) => state.auth.profile?.user?.role?.ref_id);
  const { mutate: confirmTransport } = useConfirmOrderTransport();

  const { data: shippingBrand, isLoading } = useGetShippingBand();
 
  useEffect(() => {
    formPostal.resetFields();
    if (item.address_remark) {
      formPostal.setFieldsValue({
        remark: item?.address_remark,
      });
    }
  }, [formPostal, item]);
  
  const childrenShippingBrand: React.ReactNode[] = [];
  shippingBrand?.data.map((i) => {
    return childrenShippingBrand.push(
      <Option key={i.id} value={i.id}>
        {i.description}
      </Option>
    );
  });

  const handelFinish = (value: any) => {
    const retail_order_item_id: string[] = [];
    item?.items.map((i) => {
      i.keys.items.map((j) => {
        retail_order_item_id.push(j);
      });
    });

    const transport_postal_list: Transportpostallist[] = [];

    retail_order_item_id.map((i, index) => {
      return transport_postal_list.push({
        order_id: item?.order_id,
        order_item_id: i,
        product_id: item?.items[index].product_id,
        postal_code: value.postalCode,
        remark: value.remark,
        description: value.description,
        doc_date: dayjs().format("YYYY-MM-DD HH:mm:ss"),
        agent_id: item?.ref_id,
        brand_id: value.selectOrganize,
      });
    });

    confirmTransport(
      {
        factory_id: factoryId || '',
        remark: "",
        transport_bus_list: [],
        transport_postal_list: transport_postal_list,
        memo: memo
      },
      {
        onSuccess: async (res) => {
          if (res.status === "success") {
            message.success("ยืนยันการส่งสำเร็จ");
            refetchData();
            refectShipped && refectShipped();
            onClose();
          } else {
            message.error(`ยืนยันการส่งไม่สำเร็จ ${res.error_message}`);
          }
        },
        onError: (error) => {
          console.log(error);
        },
      }
    );
  };

  return (
    <div>
      <div style={{ marginBottom: 10 }}>
        <Typography.Text style={{ fontSize: 14, fontWeight: 400 }}>
          กำหนดการจัดส่ง
        </Typography.Text>
      </div>
      <Form form={formPostal} onFinish={handelFinish}>
        <Form.Item
          label="ประเภทขนส่ง"
          name="selectOrganize"
          rules={[{ required: true, message: "กรุณาเลือกประเภทขนส่ง" }]}
        >
            <Select
              showSearch
              placeholder="เลือกประเภทขนส่ง"
              optionFilterProp="children"
            >
              {childrenShippingBrand}
            </Select>
        </Form.Item>
        <Form.Item
          label="เลข Tracking"
          name="postalCode"
          rules={[{ required: true, message: "กรุณากรอกเลข Tracking" }]}
        >
          <Input size="small" placeholder="เลข Tracking" autoComplete="off"/>
        </Form.Item>
        {/* <Form.Item label="รายละเอียด" name="description">
          <Input.TextArea placeholder="รายละเอียด" />
        </Form.Item> */}
        <Form.Item label="หมายเหตุจัดส่ง" name="remark">
          <Input placeholder="หมายเหตุจัดส่ง" />
        </Form.Item>
      </Form>
    </div>
  );
};

export default PostalSelect;
